module.exports = __webpack_public_path__ + "static/media/kake_red-min.a5135cda.png";